import { render, staticRenderFns } from "./gc-inactive.vue?vue&type=template&id=1fc750cc&scoped=true"
import script from "./gc-inactive.vue?vue&type=script&lang=js"
export * from "./gc-inactive.vue?vue&type=script&lang=js"
import style0 from "./gc-inactive.vue?vue&type=style&index=0&id=1fc750cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc750cc",
  null
  
)

export default component.exports